// Voeg deze JavaScript toe aan je theme.js of een nieuw .js bestand in je Assets map
document.addEventListener("DOMContentLoaded", function() {
    // Krijg de huidige datum
    let currentDate = new Date();

    // Functie om de datum in het juiste formaat weer te geven (dd-mm-yyyy)
    function formatDate(date) {
        let day = String(date.getDate()).padStart(2, '0');
        let month = String(date.getMonth() + 1).padStart(2, '0'); // Maanden zijn 0-gebaseerd
        let year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    // Bereken de verwachte leverdatum (5-10 dagen later)
    let deliveryDate = new Date(currentDate);
    deliveryDate.setDate(currentDate.getDate() + (Math.random() * 5 + 5)); // 5-10 dagen later

    // Format de leverdatum en vul de tekst in
    const deliveryMessage = `Vandaag besteld is ${formatDate(deliveryDate)} in huis`;

    // Vul de dynamische tekst in de HTML
    document.getElementById("delivery-message").textContent = deliveryMessage;
});
